import React, { useState } from 'react';
import {
  UploadFile,
  UploadValue,
  useUploadLogic,
  UploadFilesProps,
  UploadFilesContainer,
} from 'design-system';

import { uploadImages } from 'src/services/user';

export default function UploadMedia<T extends UploadValue>({
  value,
  onChange,
  maxCount = 6,
  accept = '.jpg,.png,.pdf,.docx,.xlsx',
  supportedFormats = accept ? accept.split(',') : [],
  isDownload = false,
  disabled = false,
  onUpload = uploadImages,
  ...rest
}: UploadFilesProps<T>) {
  const { fileList, images, uploading, handleFileUpload, handleFileChange, handleRemoveFile } =
    useUploadLogic<T>({
      value,
      onChange,
      maxCount,
      disabled,
      onUpload,
    });
  const [current, setCurrent] = useState<number>();
  const [visible, setVisible] = useState<boolean>(false);

  const [previewFile, setPreviewFile] = useState<UploadFile | null>(null);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);

  const handleDocumentPreview = (file: UploadFile) => {
    setPreviewFile(file);
    setIsPreviewModalOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewModalOpen(false);
    setPreviewFile(null);
  };

  return (
    <UploadFilesContainer
      {...rest}
      maxCount={maxCount}
      accept={accept}
      supportedFormats={supportedFormats}
      isDownload={isDownload}
      disabled={disabled}
      fileList={fileList}
      images={images}
      uploading={uploading}
      handleFileUpload={handleFileUpload}
      handleFileChange={handleFileChange}
      handleRemoveFile={handleRemoveFile}
      previewFile={previewFile}
      isPreviewModalOpen={isPreviewModalOpen}
      handleDocumentPreview={handleDocumentPreview}
      handleClosePreview={handleClosePreview}
      current={current}
      visible={visible}
      setCurrent={setCurrent}
      setVisible={setVisible}
    />
  );
}
